import { render, staticRenderFns } from "./GroupEdit.vue?vue&type=template&id=657d6130&scoped=true&"
import script from "./GroupEdit.vue?vue&type=script&lang=js&"
export * from "./GroupEdit.vue?vue&type=script&lang=js&"
import style0 from "./GroupEdit.vue?vue&type=style&index=0&id=657d6130&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657d6130",
  null
  
)

export default component.exports